(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["RedEnvelopeEntrance"] = factory(require("vue"));
	else
		root["PolyvIRScene"] = root["PolyvIRScene"] || {}, root["PolyvIRScene"]["RedEnvelopeEntrance"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__116__) {
return 